import * as React from 'react'
import VehicleActivitiesActionBar from '../shared/actionBars/VehicleActivitiesActionBar'
import Daily from '../tabs/activities/views/Daily'

export const VehicleDailyActivityPage = () => (
  <div className="tw-flex tw-flex-1 tw-flex-col tw-overflow-hidden">
    <div className="tw-relative tw-flex-shrink-0 tw-border-b tw-border-base-200 tw-bg-white">
      <VehicleActivitiesActionBar printView="daily" />
    </div>
    <Daily />
  </div>
)
